import React, { Component } from 'react';
import Card, { cardTypes } from '../../../CardNew';
import { TALENTS } from '../../constants';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import './styles.scss';

class RibbonTalent extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.ribbonIndex = props.index;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.history = props.history;
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;
    }

    render() {
        return (
            <div className="ribbon-items ribbon-talent">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    let badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    let uri = node_item.src;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };
                    return (
                        <Card
                            unFocusHandler={this.unFocusHandler}
                            id={index + 1}
                            ribbonId={this.ribbonId}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            typeRender={node_item.typeRender || null}
                            data={node_item}
                            group_id={node_item.group_id || node_item.id}
                            cover={node_item.cover}
                            hideTitles={this.props.hideTitles}
                            label={node_item.label}
                            type={TALENTS}
                            title={node_item.title}
                            group_name={node_item.groupName}
                            text_highlight={node_item.text_highlight}
                            text_subtitle={node_item.text_subtitle}
                            image_highlight={
                                node_item.image_highlight
                                    ? node_item.image_highlight
                                    : node_item.cover
                                    ? node_item.cover
                                    : ''
                            }
                            badgesHtml={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusHandler={this.focusHandler}
                            setMetricsEvent={this.setMetricsEvent}
                            clickHandler={node_item.clickHandler || this.onClickHandler}
                           onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon);
                                if(node_item.type === "live"){
                                e.preventDefault();
                                e.stopPropagation();
                                this.onClickHandler(node_item)
                                }else{
                                  if (node_item.clickHandler) node_item.clickHandler();
                                }
                            }}
                            sibling={node_item.sibling}
                            href={uri}
                            hideInnerTitle={this.hideInnerTitle}
                            bookmark={node_item.bookmark ? String(node_item.bookmark) : '0'}
                            keyDownHandler={this.keyDownHandler}
                            filterTV={node_item.filterTV ? node_item.filterTV : null}
                            is_music={this.props.isMusicRibbon ? true : false}
                            ribbonName={this.ribbonName}
                            ribbonLength= {this.visibleItems.length}
                            history={this.history}
                            idsRibbonsUpAndDown={this.idsRibbonsUpAndDown}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonTalent;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonTalent/index.jsx